import { AUTH_TYPES, TEMPLATE_CATEGORIES } from './constants.js'

export const segmentTemplate = {
	id: 'segment',
	guid: 'c9d26e2f-1980-40f7-9491-8819a7f35d41',
	name: 'Segment',
	category: TEMPLATE_CATEGORIES.ANALYTICS,
	popularity: 'Popular',
	color: '#52bd95',
	icon: 'mdi-chart-line',
	description: 'Connect to Segment for customer data integration.',
	features: ['API Key Auth', 'Event Tracking', 'User Identification', 'Data Routing'],
	configFields: [
		{ name: 'writeKey', label: 'Write Key', type: 'password', required: true, placeholder: 'Enter your Segment write key' }
	],
	endpoints: [
		{
			name: 'Identify User',
			url: 'https://api.segment.io/v1/identify',
			method: 'POST',
			description: 'Identify a user with traits',
			cassieObjectID: -3,
			incrementField: 'syrenisID',
			resetIncrementValue: false,
			fields: [
				{ name: 'SyrenisID', filter: '' },
				{ name: 'Forename', filter: '' },
				{ name: 'Surname', filter: '' },
				{ name: 'Email1', filter: '' },
				{ name: 'DataSubjectDateAdded_UTC', filter: '' }
			],
			requestBody: '{ "userId": "[PLACEHOLDER_SYRENISID]", "traits": { "email": "[PLACEHOLDER_EMAIL1]", "name": "[PLACEHOLDER_FORENAME] [PLACEHOLDER_SURNAME]", "plan": "premium", "createdAt": "[PLACEHOLDER_DATASUBJECTDATEADDED_UTC]" }}',
			headers: [{ Name: 'Authorization', value: 'Basic [writeKey]' }],
			successResponses: [{ code: 200, message: '' }]
		},
		{
			name: 'Add User Event',
			url: 'https://api.segment.io/v1/track',
			method: 'POST',
			description: 'Track lets you record the actions your users perform',
			cassieObjectID: -5,
			incrementField: 'PreferenceID',
			resetIncrementValue: false,
			fields: [
				{ name: 'SyrenisID', filter: '' },
				{ name: 'ChannelID', filter: '' },
				{ name: 'ConsentValue', filter: '' }

			],
			requestBody: '{ "userId": "[PLACEHOLDER_SYRENISID]", "event": "[PLACEHOLDER_CHANNELID]", "properties": { "consentValue": "[PLACEHOLDER_CONSENTVALUE]"}}',
			headers: [{ Name: 'Authorization', value:	'Basic [writeKey]' }],
			successResponses: [{ code: 200, message: '' }]
		}
	],
	defaults: {
		endpointAddress: 'https://api.segment.io/v1',
		authenticationTypeId: AUTH_TYPES.API_KEY,
		frequencyInSeconds: 0,
		notes: 'Segment customer data platform integration for unified data collection and routing.'
	}
}
